export default "__VITE_ASSET__dvrpmBZm__"